// V70.65 — Sayfa grupları: sidebar'da grup başına TEK giriş, grup sayfalarının
// üstünde yatay sekme şeridi (PageGroupTabs). Rotalar ve sayfalar DEĞİŞMEDİ —
// sekmeler gerçek rotalara NavLink'tir; kullanıcının yetkisi olmayan sekme görünmez.
// Sidebar ve PageGroupTabs aynı konfigürasyonu paylaşır (tek kaynak).

// V70.66 — her grubun renk kimliği: sekme şeridi etiketi + aktif sekme gradyanı bu ikiliden üretilir
export const PAGE_GROUPS = [
  // V71.25 — Uçak + Otel Operasyon TEK GRUP (kullanıcı isteği). Sekmeler yetkiye göre:
  // bilet departmanı uçak, otel departmanı otel sayfalarını görür. İki arama sayfasını da
  // gören kullanıcıda şeritte tek "Arama" sekmesi olur; geçiş arama kutusunun üstündeki
  // pill'den (OpsSearchSwitch). dept: Bilet Düzenleyici ve sidebar canlılık noktası için.
  {
    key: 'operasyon', label: 'Operasyon', emoji: '🧳', color: ['#4338ca', '#6366f1'],
    items: [
      { to: '/flight-search', label: 'Uçuş Arama', pill: '✈️ Uçak', dept: 'ucak', perm: ['flight_search', 'view'] },
      { to: '/hotel-search', label: 'Otel Arama', pill: '🏨 Otel', dept: 'otel', permAny: [['hotel_rates', 'view'], ['reservations', 'view'], ['hotel_options', 'view']] },
      { to: '/tickets', label: 'Açık Biletler', dept: 'ucak', perm: ['tickets', 'view'] },
      { to: '/checkins', label: 'Check-in', dept: 'ucak', permAny: [['checkin', 'view'], ['tickets', 'view']] }, // V71 — rota+backend ile aynı
      { to: '/hotel-rates', label: 'Otel Fiyatları', dept: 'otel', perm: ['hotel_rates', 'view'] },
      { to: '/free-nights', label: 'Ücretsiz Geceler', dept: 'otel', perm: ['free_nights', 'view'] },
    ],
  },
  {
    key: 'vize', label: 'Vize İşleri', emoji: '🛂', color: ['#0284c7', '#38bdf8'],
    items: [
      { to: '/visas', label: 'Vize İşlemleri', perm: ['visas', 'view'] },
      { to: '/visa-system', label: 'Vize Sistemi', perm: ['visa_system', 'view'] },
      { to: '/visa-requirements', label: 'Evrak Bilgileri', perm: ['visa_requirements', 'view'] },
    ],
  },
  // V71.26 — Finans & Muhasebe grubu kapandı: Kart İşlemleri TRIS'e geçti, Şifre Akışı Sistem'e,
  // Firma Yönetimi tek satır (SOLO_PAGES). Rotalar App.js'te yönleniyor; veri/backend silinmedi.
  {
    key: 'pazarlama', label: 'Pazarlama', emoji: '🎯', color: ['#db2777', '#f472b6'],
    items: [
      { to: '/marketing', label: 'Müşteri Fırsatları', perm: ['marketing', 'view'] },
      { to: '/fuar-firsatlari', label: 'Fuar Fırsatları', perm: ['marketing', 'view'] }, // V71.37
      { to: '/mailing', label: 'Mailing', perm: ['mailing', 'view'] },
      { to: '/itinera-leads', label: 'ITINERA Talepleri', perm: ['itinera_leads', 'view'] },
    ],
  },
  {
    // V71.26 — grup düzeyinde adminOnly yok (her sayfa kendi işaretini taşır): Şifre Akışı
    // otp_feed yetkili admin olmayan kullanıcıya da görünsün
    key: 'sistem', label: 'Sistem', emoji: '🛡️', color: ['#334155', '#64748b'],
    // V71.45 — 16 sekme şeride sığmıyordu: Genel Bakış + 5 açılır menü (sec). Kontrol Merkezi de bu listeden çizilir;
    // yeni sistem sayfası buraya sec + desc ile eklenir (Settings.js'de ayrı liste yok)
    sections: [
      { key: 'erisim', label: 'Erişim' },
      { key: 'izleme', label: 'İzleme', full: 'İzleme & Güvenlik' },
      { key: 'servis', label: 'Servisler', full: 'Servisler & Entegrasyon' },
      { key: 'veri', label: 'Veri & Referans' },
      { key: 'urun', label: 'Ürün' },
    ],
    items: [
      { to: '/settings', label: 'Genel Bakış', adminOnly: true },
      { to: '/users', label: 'Kullanıcılar & Yetkiler', sec: 'erisim', desc: 'Kullanıcılar, roller ve erişim', adminOnly: true },
      { to: '/notification-settings', label: 'Bildirimler', sec: 'erisim', desc: 'E-posta ve hatırlatma ayarları', adminOnly: true },
      { to: '/announcements', label: 'Duyurular', sec: 'erisim', desc: 'Duyuru oluşturma ve yayınlama', adminOnly: true },
      { to: '/my-dashboard', label: 'Dashboard Ayarları', sec: 'erisim', desc: 'Kişisel görünüm ve departman şablonları', adminOnly: true },
      { to: '/admin/saglik', label: 'Sistem Sağlığı', sec: 'izleme', desc: 'Altyapı, yedek ve servis kontrolleri', adminOnly: true }, // V71.38
      { to: '/admin/error-log', label: 'Hata Kayıtları', sec: 'izleme', desc: 'Uygulama ve sunucu hataları', adminOnly: true }, // V71.17
      { to: '/admin/audit-log', label: 'Denetim Kaydı', sec: 'izleme', desc: 'Kayıt değişiklik geçmişi', adminOnly: true },
      { to: '/admin/backup', label: 'Yedekler', sec: 'izleme', desc: 'Veritabanı yedekleri ve indirme', adminOnly: true },
      { to: '/endpoint-dashboard', label: 'Endpoint İzleme', sec: 'izleme', desc: 'API uçları ve durum izleme', adminOnly: true },
      { to: '/admin/integrations', label: 'Entegrasyonlar', sec: 'servis', desc: 'API anahtarları ve webhook tanımları', adminOnly: true },
      { to: '/admin/santral', label: 'Santral', sec: 'servis', desc: 'Çağrılar, rehber ve mesai', adminOnly: true }, // V71.8
      { to: '/admin/yapay-zeka', label: 'Yapay Zekâ', sec: 'servis', desc: 'Harcama ve aylık sınır', adminOnly: true }, // V71.43
      { to: '/otp-feed', label: 'Şifre Akışı', sec: 'servis', desc: 'Gelen OTP ve doğrulama kodları', perm: ['otp_feed', 'view'] }, // V71.26 — Kart Merkezi'nden
      { to: '/portal-management', label: 'Müşteri Portalı', sec: 'servis', desc: 'Portal yapılandırması', adminOnly: true },
      { to: '/transfers', label: 'Aktarımlar', sec: 'servis', desc: 'Excel ve toplu veri işlemleri', adminOnly: true },
      { to: '/admin/flight-providers', label: 'Uçuş Sağlayıcıları', sec: 'veri', desc: 'Havayolu ve havalimanı tanımları', adminOnly: true },
      // V70.127 — Otel Arama'daki destinasyon teşhis bloğunun tam sayfa hâli (kullanıcı isteği)
      { to: '/admin/hotel-destinations', label: 'Otel Destinasyonları', sec: 'veri', desc: 'Otel arama destinasyonları', adminOnly: true },
      // V70.141 — Uçuş+Otel arama logları ve sonuç fiyatları (veri analizi)
      { to: '/admin/search-logs', label: 'Arama Kayıtları', sec: 'veri', desc: 'Uçuş ve otel arama logları', adminOnly: true },
      // V70.147 — Arama loglarının kapsamlı analizi (trend/fiyat/sağlayıcı/kullanıcı)
      { to: '/admin/search-analytics', label: 'Arama Analizi', sec: 'veri', desc: 'Trend, fiyat ve sağlayıcı analizi', adminOnly: true },
      { to: '/voucher-template', label: 'Voucher Şablonu', sec: 'veri', desc: 'İptal kuralları ve ibareler', adminOnly: true },
      { to: '/admin/beta', label: 'Beta Özellikler', sec: 'urun', desc: 'E-posta koduyla açılan özellikler', adminOnly: true }, // V71.36
      { to: '/admin/ratehawk', label: 'RateHawk Deneme', sec: 'urun', desc: 'Otel arama, rezervasyon ve iptal (sertifikasyon)', adminOnly: true }, // V71.52
      { to: '/admin/ideas', label: 'Fikirler', sec: 'urun', desc: 'Fikrim Var öneri ve hata bildirimleri', adminOnly: true },
      { to: '/changelog', label: 'Sürüm Notları', sec: 'urun', desc: 'Yayınlanan değişiklikler', adminOnly: true },
    ],
  },
];

// V71.14.3 — grupsuz sayfalar: üst çubukla birleşen tek satırda sayfa adı (sidebar etiket + renk)
export const SOLO_PAGES = [
  { to: '/ops-map', label: 'Operasyon Haritası', emoji: '🗺️', color: ['#302880', '#3b82f6'] }, // V71.16
  { to: '/customers', label: 'Yolcu Listesi', emoji: '👥', color: ['#0891b2', '#22d3ee'] },
  { to: '/companies', label: 'Firma Yönetimi', emoji: '🏢', color: ['#047857', '#10b981'] }, // V71.26
  { to: '/calendar', label: 'Takvim', emoji: '📅', color: ['#d97706', '#fbbf24'] },
  { to: '/whatsapp', label: 'Müşteri Hattı', emoji: '💬', color: ['#15803d', '#25d366'] },
  { to: '/rezervasyonlar', label: 'Rezervasyonlar', emoji: '🗂️', color: ['#7c3aed', '#a78bfa'] }, // V71.24
  { to: '/shared-files', label: 'Dosya Paylaşım', emoji: '📁', color: ['#0d9488', '#2dd4bf'] },
  { to: '/rehberim', label: 'Rehberim', emoji: '📞', color: ['#0f766e', '#14b8a6'] },
  { to: '/haberler', label: 'Sektör Haberleri', emoji: '📰', color: ['#0369a1', '#38bdf8'] }, // V71.32
  { to: '/announcements', label: 'Duyurular', emoji: '📣', color: ['#4f46e5', '#818cf8'] },
  { to: '/transfers', label: 'Aktarımlar', emoji: '🔄', color: ['#334155', '#64748b'] },
  { to: '/tasks', label: 'Görevler', emoji: '✅', color: ['#4f46e5', '#818cf8'] },
  { to: '/notifications', label: 'Bildirimler', emoji: '🔔', color: ['#4f46e5', '#818cf8'] },
];
export const findSoloPage = (pathname) =>
  SOLO_PAGES.find(p => pathname === p.to || pathname.startsWith(p.to + '/')) || null;

// V71.25 — arama kutusunun üstündeki Uçak/Otel pill'i: kullanıcının görebildiği arama sayfaları
export const getSearchPills = (hasPermission, isAdmin) =>
  PAGE_GROUPS.flatMap(g => g.items).filter(i => i.pill && canSeeGroupItem(i, hasPermission, isAdmin));

// Sayfanın hangi gruba ait olduğunu bul (alt path'ler dahil: /hr/staff/9 değil ama /krediler/x evet)
export const findGroupForPath = (pathname) =>
  PAGE_GROUPS.find(g => g.items.some(i => pathname === i.to || pathname.startsWith(i.to + '/'))) || null;

// V71 — şeritte sekmesi olmayan yönetim sayfaları: sidebar'da yalnız grup vurgusu için (şerit çizilmez)
// V71.45 — diğerleri artık Sistem menüsünde (sec); /dashboard-management yalnız yönlendirme
const SIDEBAR_GROUP_ALIASES = {
  sistem: ['/dashboard-management'],
};
export const findSidebarGroupKey = (pathname) => {
  const g = findGroupForPath(pathname);
  if (g) return g.key;
  const hit = Object.entries(SIDEBAR_GROUP_ALIASES).find(([, paths]) => paths.some(p => pathname === p || pathname.startsWith(p + '/')));
  return hit ? hit[0] : null;
};

// Sidebar canSeeLink ile aynı kurallar — tek kaynak burada
export const canSeeGroupItem = (item, hasPermission, isAdmin) => {
  if (item.adminOnly && !isAdmin) return false;
  if (item.permAny) return item.permAny.some(([m, a]) => hasPermission(m, a));
  if (!item.perm) return true;
  return hasPermission(item.perm[0], item.perm[1]);
};

// V71 — TEK KARAR NOKTASI: kullanıcının bu yoldaki grubu + görebildiği sekmeler.
// Sekme şeridi (PageGroupTabs) ve .pg-grouped başlık gizleme (AppLayout) aynı sonucu kullanır;
// görünür sekme 2'den azsa şerit çizilmez ve sayfanın kendi başlığı da gizlenmez.
export const getVisibleGroup = (pathname, hasPermission, isAdmin) => {
  const group = findGroupForPath(pathname);
  if (!group || (group.adminOnly && !isAdmin)) return null;
  let visible = group.items.filter(i => canSeeGroupItem(i, hasPermission, isAdmin));
  // V71.25 — iki arama sayfası da görünüyorsa şeritte tek "Arama" sekmesi (bulunulan aramaya gider)
  const pills = visible.filter(i => i.pill);
  if (pills.length === 2) {
    const cur = pills.find(i => pathname === i.to || pathname.startsWith(i.to + '/')) || pills[0];
    visible = visible.filter(i => !i.pill || i === pills[0]).map(i => (i === pills[0] ? { ...cur, label: 'Arama' } : i));
  }
  return { group, visible, showTabs: visible.length >= 2 };
};
